import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

/**
 * Normalize media URLs:
 * - absolute URLs (http/https/data) → returned as-is
 * - legacy `/uploads/X` → rewritten to `/api/uploads/X` (works through ingress + nginx /api proxy)
 * - any other path → returned as-is
 */
export function mediaUrl(url) {
  if (!url) return "";
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith("/uploads/")) return `/api${url}`;
  return url;
}


/**
 * Kebab-case slug for a policy/legal document name, used for /legal/:slug routes.
 * "Security & Responsible AI Statement" → "security-responsible-ai-statement"
 */
export function policySlug(name) {
  return (name || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}


/**
 * Given a reel row, return the best available thumbnail URL.
 * Prefers the manually-set `cover_image`; if empty, derives one from the
 * Cloudflare Stream video URL. If neither is available, returns "".
 *
 * Cloudflare thumbnail convention:
 *   video HLS  →  https://customer-xxx.cloudflarestream.com/<uid>/manifest/video.m3u8
 *   thumbnail  →  https://customer-xxx.cloudflarestream.com/<uid>/thumbnails/thumbnail.jpg
 */
export function reelThumbnail(reel) {
  if (!reel) return "";
  if (reel.cover_image) return mediaUrl(reel.cover_image);
  const v = reel.video_url || "";
  const m = v.match(/^(https?:\/\/[^/]*cloudflarestream\.com\/[a-f0-9]{32})\//i);
  if (m) return `${m[1]}/thumbnails/thumbnail.jpg`;
  return "";
}
